<div class="display-layout-column layout-gap-15">
  <div class="headline">
    <button mat-button routerLink="/requests">
      <mat-icon>keyboard_arrow_left</mat-icon>
      Back to overview
    </button>
  </div>

  <div class="display-layout-column layout-gap-32">
    <!-- EXPANSION PANEL-->

    <!-- header panel-->
    <div>
      <div class="overviewHeader">Overview</div>
      <mat-accordion>
        <mat-expansion-panel class="headerPanel" expanded>
          <div class="display-layout-row layout-align-start-start">
            <div class="display-layout-column">
              <div>
                <mat-chip-set>
                  <strong>Status</strong>
                  <mat-chip [ngClass]="getStatusStyle()">
                  {{ getStatus() }}</mat-chip>
                </mat-chip-set>
              </div>
              <div>
                <b>RequestID:</b> {{ request?.requestID }}
              </div>
              <div>
                <b>PartialRequestID:</b> {{ request?.partRequestID }}
              </div>
              <div>
                <b>PartPrimaryRequestID:</b>{{ request?.partPrimaryRequestID }}
              </div>
              <br>
                <div><b>Customer Email: </b>{{ request?.customer?.email }}</div>
                <div><b>Customer Name: </b>
                {{ request?.customer?.firstName }}
                {{ request?.customer?.lastName }}
              </div>
              <div><b>Company Name: </b>{{ request?.customer?.companyName }}</div>
              <br>
                <div>
                  <b>Final Destination:</b>
                  {{ request?.finalDestination }}
                </div>
                <div><b>Number of Parcels:</b> {{ request?.numberOfParcels }}</div>
                <div><b>Actual Weight:</b> {{ request?.weight }}kg</div>
                <div><b>Chargeable Weight:</b> {{ request?.chargeableWeight }}kg</div>
                <div><b>Stackable:</b> {{ request?.stackable ? 'Yes' : 'No' }}</div>

                <div><b>Target Rate:</b> {{ request?.targetRate }}</div>
                <div>
                  <b> Available Ex Origin:</b>
                  {{ request?.availableExOrigin | date: 'dd/MM/yyyy' }}
                </div>
                <div>
                  <b>Special Cargo:</b> {{ request?.specialCargoRequest }}
                </div>
                <div><b>Note:</b>
                <span [innerHTML]="request?.note"></span>

              </div>
            </div>
            <div class="display-flex"></div>
            <div class="display-layout-row layout-gap-32 justify-content-end align-items-start" [formGroup]="advancedDetailsForm">
              <div class="advancedInput display-layout-column display-flex justify-content-start">
                <mat-form-field>
                  <mat-label>AWB ID</mat-label>
                  <input matInput formControlName="awbID" />
                </mat-form-field>

                <mat-form-field>
                  <mat-label>Purchase Price</mat-label>
                  <input matInput formControlName="purchasePrice" />
                </mat-form-field>

                <mat-form-field>
                  <mat-label>Selling Price</mat-label>
                  <input matInput formControlName="sellingPrice" />
                </mat-form-field>

                <mat-form-field appearance="fill">
                  <mat-label>Change Status</mat-label>
                  <mat-select formControlName="status">
                    @for (option of statusOptions; track option) {
                      <mat-option [value]="option.value">{{ option.viewValue }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>



              </div>
              <div class="display-layout-column display-flex" style="max-width: 100%">
                <mat-form-field>
                  <mat-label>Internal note</mat-label>
                  <textarea matInput class="noteAdmin" formControlName="noteAdmin"> </textarea>
                </mat-form-field>

                <div class="display-flex"></div>
                <button mat-stroked-button
                  [disabled]="!advancedDetailsForm.controls.status.dirty && !advancedDetailsForm.controls.awbID.dirty && !advancedDetailsForm.controls.purchasePrice.dirty && !advancedDetailsForm.controls.sellingPrice.dirty && !advancedDetailsForm.controls.noteAdmin.dirty"
                  (click)="updateRequest()">
                  Save
                </button>
              </div>
            </div>
          </div>
          <mat-divider></mat-divider>
          <div class="request-attachments">
            <div><strong>Attachments:</strong> </div>
            @for (attachment of getRequestAttachments(); track attachment) {
              <div>
                <div class="attachment-underlined" matTooltip="Click to download"
                  (click)="downloadRequestAttachment(attachment.requestAttachmentId)">{{attachment.name}}
                </div>
              </div>
            }
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    <div class="communicationHeader">Communication</div>
  </div>

  <!-- new email-->
  <button (click)="toggleNewMail()" mat-stroked-button class="emailButton">
    <mat-icon>mail_outline</mat-icon> New Mail
  </button>

  @if (emailToggled) {
    <div>
      <mat-accordion>
        <mat-expansion-panel class="newMail" [formGroup]="newEmailForm" expanded hideToggle>
          <div class="display-layout-column layout-gap-32">
            <div class="layout-gap-15" [class.display-layout-row]="recipient == 'customer'" [class.display-layout-column]="recipient != 'customer'">
              @if (!replyToggled) {
                <mat-form-field class="optionsField" appearance="fill">
                  <mat-label>Option</mat-label>
                  <mat-select formControlName="option" required>
                    @for (option of newMailOptions; track option) {
                      <mat-option [value]="option.value">{{ option.viewValue }}
                      </mat-option>
                    }
                  </mat-select>
                  @if (newEmailForm.controls['option'].hasError('required')) {
                    <mat-error>
                      Option is <strong>required</strong>
                    </mat-error>
                  }
                </mat-form-field>
              }
              <!-- customer-->
              @if (recipient == 'customer' || replyToggled || recipient == 'email' ) {
                <div class="display-layout-column">
                  <div style="color: gray;" >
                    SEND TO: {{ newEmailForm.controls['option'].value ==  'EMAIL' ? '' : this.replyToAllString}}
                  </div>
                  <div>
                    <mat-form-field style="flex: 1 1 250px; max-width: 250px;" appearance="fill">
                      <mat-label>Recipient</mat-label>
                      <input matInput formControlName="recipient" type="email" required />
                      @if (newEmailForm.controls['recipient'].hasError('email')) {
                        <mat-error>
                          This is not a correct <strong>email</strong>
                        </mat-error>
                      }
                    </mat-form-field>
                  </div>
                </div>
              }
              <!--all airlines-->
              @if (recipient == 'airline') {
                <div class="display-layout-row layout-gap-15">
                  <div class="display-layout-column" style="flex: 1 1 70%; max-width: 70%">
                    <table mat-table [dataSource]="airlineDataSource" class="display-flex">
                      <ng-container matColumnDef="select">
                        <th mat-header-cell *matHeaderCellDef>
                      <mat-checkbox (change)="$event ? masterToggleAirline() : null" [checked]="
                            airlineSelection.hasValue() &&
                            isAllSelectedAirline()
                          " [indeterminate]="
                            airlineSelection.hasValue() &&
                            !isAllSelectedAirline()
                          " [aria-label]="checkboxLabelAirline()">
                          </mat-checkbox>
                        </th>
                        <td mat-cell *matCellDef="let row">
                          <mat-checkbox (click)="$event.stopPropagation()"
                            (change)="$event ? airlineSelection.toggle(row): null"
                            [checked]="airlineSelection.isSelected(row)" [aria-label]="checkboxLabelAirline(row)">
                          </mat-checkbox>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="id">
                        <th mat-header-cell *matHeaderCellDef>id</th>
                        <td mat-cell *matCellDef="let element">
                          {{ element.id }}
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="airlineName">
                        <th mat-header-cell *matHeaderCellDef>Name</th>
                        <td mat-cell *matCellDef="let element">
                          {{ element.airlineName }}
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="abbreviation">
                        <th mat-header-cell *matHeaderCellDef>Abbreviation</th>
                        <td mat-cell *matCellDef="let element">
                          {{ element.abbreviation }}
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="iata">
                        <th mat-header-cell *matHeaderCellDef>IATA</th>
                        <td mat-cell *matCellDef="let element">
                          {{ element.iata }}
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef>Status</th>
                        <td mat-cell *matCellDef="let element">
                      <mat-chip [ngClass]="
                            element.status == 0
                              ? 'inactiveStatus'
                              : 'activeStatus'
                          ">
                            {{
                            element.status == 0 ? "Inactive" : "Active"
                          }}</mat-chip>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="GSA">
                        <th mat-header-cell *matHeaderCellDef>GSA</th>
                        <td mat-cell *matCellDef="let element">
                          {{ getGSA(element) }}
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let element">
                          <button mat-icon-button (click)="openErateSheet(element.id)">
                            <mat-icon>insert_drive_file</mat-icon>
                          </button>
                        </td>
                      </ng-container>
                      <tr mat-header-row *matHeaderRowDef="displayedAirlineColumns"></tr>
                      <tr mat-row *matRowDef="let row; columns: displayedAirlineColumns"
                      (click)="airlineSelection.toggle(row)"></tr>
                    </table>
                    <mat-paginator #airlinePaginator [pageSize]="5" [pageSizeOptions]="[10, 20, 25]" showFirstLastButtons>
                    </mat-paginator>
                  </div>
                  <div>
                    <div class="selectedRecipients">Selected Recipients:</div>
                    <mat-hint><strong>Only airlines with contact persons can be selected</strong> </mat-hint>
                    <!--go through selected airline contacts-->
                    <!-- <div *ngFor="let item of airlineSelection.selected">
                    do not show airline contacts when there is a GSA
                    <div *ngIf="selectedGSAs.length == 0">
                      <div *ngFor="let contact of item.contacts">
                        {{ item.id }} | {{ contact.contactMail }}
                      </div>
                    </div>
                    go through selected gsa contact
                    <div *ngFor="let gsa of selectedGSAs">
                      <div *ngFor="let gsaContact of gsa.contacts">
                        {{ item.id }} | {{ gsaContact.contactMail }}
                      </div>
                    </div>
                  </div> -->
                  @for (recipient of airlineRecipients; track recipient) {
                    <div>
                      @for (contact of recipient.contacts; track contact) {
                        <div>
                          {{ recipient.airlineId }} | {{ contact.contactMail }}
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
            }
            <!--broker-->
            @if (recipient == 'broker') {
              <div class="display-layout-row layout-gap-15">
                <div class="display-layout-column" style="flex: 1 1 70%; max-width: 70%;">
                  <table mat-table [dataSource]="brokerDataSource">
                    <ng-container matColumnDef="select">
                      <th mat-header-cell *matHeaderCellDef>
                      <mat-checkbox (change)="$event ? masterToggleBroker() : null" [checked]="
                            brokerSelection.hasValue() && isAllSelectedBroker()
                          " [indeterminate]="
                            brokerSelection.hasValue() && !isAllSelectedBroker()
                          " [aria-label]="checkboxLabelBroker()">
                        </mat-checkbox>
                      </th>
                      <td mat-cell *matCellDef="let row">
                        <mat-checkbox (click)="$event.stopPropagation()"
                          (change)="$event ? brokerSelection.toggle(row) : null"
                          [checked]="brokerSelection.isSelected(row)" [aria-label]="checkboxLabelBroker(row)">
                        </mat-checkbox>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="id">
                      <th mat-header-cell *matHeaderCellDef>id</th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.id }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="brokerName">
                      <th mat-header-cell *matHeaderCellDef>Name</th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.brokerName }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="status">
                      <th mat-header-cell *matHeaderCellDef>Status</th>
                      <td mat-cell *matCellDef="let element">
                      <mat-chip [ngClass]="
                            element.status == 0
                              ? 'inactiveStatus'
                              : 'activeStatus'
                          ">
                          {{
                          element.status == 0 ? "Inactive" : "Active"
                        }}</mat-chip>
                      </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedBrokerColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedBrokerColumns"
                      (click)="brokerSelection.toggle(row)">
                    </tr>
                  </table>
                  <mat-paginator #brokerPaginator [pageSize]="5" [pageSizeOptions]="[10, 20, 25]" showFirstLastButtons>
                  </mat-paginator>
                </div>
                <div>
                  <div class="selectedRecipients">Selected Recipients:</div>
                  <mat-hint><strong>Only brokers with contact personscan be selected</strong> </mat-hint>
                  @for (item of brokerSelection.selected; track item) {
                    <div>
                      @for (contact of item.contacts; track contact) {
                        <div>
                          {{ item.id }} | {{ contact.contactMail }}
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
            }
          </div>
          <mat-form-field class="subjectField" appearance="fill">
            <mat-label>Subject</mat-label>
            <input matInput formControlName="subject" type="text" required />
            @if (newEmailForm.controls['subject'].hasError('required')) {
              <mat-error>
                Subject is <strong>required</strong>
              </mat-error>
            }
            <mat-hint><b>NOTE: </b>In order to be able to assign the message correctly, the message must contain
          the placeholder "reference"'</mat-hint>
        </mat-form-field>
        <angular-editor formControlName="message" [config]="editorConfig"></angular-editor>
        <br>
          <!-- <mat-form-field appearance="fill">
          <mat-label>Message</mat-label>
          <textarea class="textarea" matInput cdkTextareaAutosize cdkAutosizeMinRows="1" cdkAutosizeMaxRows="5"
            formControlName="message" required>
          </textarea>
          <mat-error *ngIf="newEmailForm.controls['message'].hasError('required')">
            Message is <strong>required</strong>
          </mat-error>
        </mat-form-field>-->
        <!-- area for uploading attachments-->
        <div class="display-layout-column">
          <div>Upload Attachments</div>
          <div class="upload-attachement-container display-layout-column" attachmentDnd
            (fileDropped)="onFileDropped($event)">
            <div class="display-layout-column layout-align-center-center layout-gap-15">
              <div>Drag and drop files in this area</div>
              <div>or</div>
              <button mat-stroked-button (click)="importAttachment()">
                Browse for files
              </button>
              <input type="file" #attachmentFile style="display: none" multiple accept="*"
                (change)="importBrowserFile()" />
            </div>
            @if (uploadAttachments.length > 0) {
              <div>
                <div class="upload-attachment-underlined"> Uploaded Attachments</div>
                @for (attachment of uploadAttachments; track attachment; let i = $index) {
                  <div>
                    <div class="display-layout-row layout-gap-12 justify-content-start align-items-center">
                      <div>{{attachment.name}}</div>
                      <div>{{attachment.contentType}}</div>
                      <div>{{(attachment.size / 1000000).toFixed(3)}} MB</div>
                      <button mat-icon-button matTooltip="Remove uploaded attachment"
                        (click)="deleteUploadedAttachment(i)">
                        <mat-icon>delete_outline</mat-icon>
                      </button>
                    </div>
                  </div>
                }
              </div>
            }
            @if (uploadAttachments.length > 0) {
              <div>
                <div><b>NOTE:</b> The duration of sending messages increases with the size and count of the attachments.
              </div>
              <div>Total attachment size: {{(this.attachmentsize / 1000000).toFixed(3)}} MB </div>
            </div>
          }
        </div>
      </div>
      <div class="display-layout-row justify-content-end align-items-center layout-gap-10">
        <button (click)="toggleNewMail()" mat-stroked-button>
          Cancel
        </button>
        <!--mehr als 3MB nicht möglich-->
        <!-- <button (click)="sendNewMail()" [disabled]="newEmailForm.invalid || uploadAttachmentTooBig || messageIsSending" mat-stroked-button>
        <mat-icon>forward_to_inbox</mat-icon>
        Send
      </button> -->
      <!-- mehr als 3MB zugelassen-->
      <button (click)="sendNewMail()" [disabled]="newEmailForm.invalid || messageIsSending" mat-stroked-button>
        <mat-icon>forward_to_inbox</mat-icon>
        Send
      </button>
      @if (messageIsSending) {
        <mat-spinner [diameter]="30"></mat-spinner>
      }
    </div>
  </div>
</mat-expansion-panel>
</mat-accordion>
</div>
}
<!-- message panels -->

<div class="display-layout-column layout-gap-15">
  <div>
    <mat-accordion>
      @for (message of selectedResult; track message) {
        <mat-expansion-panel class="bodyPanel">
          <mat-expansion-panel-header [ngClass]="checkIfSelected(message) ? 'checkedMsg' : null">
            <mat-panel-title class="display-layout-row layout-align-center-center">
              <div class="display-layout-row layout-gap-5 layout-align-center-center" style="min-height: 50px;">
                <div class="icon-container layout-align-center-center">
                  @if (isNewMessage(message.id)) {
                    <mat-icon class="newMail-icon" aria-hidden="false" matTooltip="NEW">
                    fiber_new</mat-icon>
                  }
                </div>
                <mat-checkbox (click)="$event.stopPropagation()" #checkbox [checked]="checkIfSelected(message)"
                  matTooltip="Mark as closed" (change)="setEditedMessage(checkbox.checked,message)" class="layout-align-center-center">
                </mat-checkbox>
                <div class="icon-container layout-align-center-center">
                  @if (message.hasAttachments) {
                    <mat-icon aria-hidden="false" matTooltip="Message has attachments">
                      attach_file
                    </mat-icon>
                  }
                </div>

                <button mat-button class="custom-email-button"
                  [disabled]="message?.from?.emailAddress?.address == 'system@vr-cargo.aero'"
                  (click)="$event.stopPropagation();toggleNewMail(); replyMail(message, 3)"
                  matTooltip="Forward this message">
                  <div class="display-layout-column layout-align-center-center">
                    <mat-icon class="flex-item-5">forward_to_inbox</mat-icon>
                    <span style="font-size: 8px; margin-top: 5px;">forward to</span>
                  </div>
                </button>

                <button mat-button class="custom-email-button"
                        [disabled]="message?.from?.emailAddress?.address == 'system@vr-cargo.aero' || message?.from?.emailAddress?.address == 'request@vr-cargo.aero'"
                        (click)="$event.stopPropagation();toggleNewMail(); replyMail(message, 2)"
                        matTooltip="Reply all to this message in one mail">
                  <div class="display-layout-column layout-align-center-center">
                    <mat-icon
                      [class.not-replyable]="message?.from?.emailAddress?.address == 'system@vr-cargo.aero' || message?.from?.emailAddress?.address == 'request@vr-cargo.aero'"
                      class="flex-item-5" fontIcon="reply_all"></mat-icon>
                    <span style="font-size: 8px; line-height: 10px;">reply all</span>
                  </div>
                </button>

                <button mat-button class="custom-email-button"
                  [disabled]="message?.from?.emailAddress?.address == 'system@vr-cargo.aero' || message?.from?.emailAddress?.address == 'request@vr-cargo.aero'"
                  (click)="$event.stopPropagation();toggleNewMail(); replyMail(message, 1)"
                  matTooltip="Reply all to this message in separate mails">
                  <div class="display-layout-column layout-align-center-center">
                    <mat-icon
                      [ngClass]="message?.from?.emailAddress?.address == 'system@vr-cargo.aero' || message?.from?.emailAddress?.address == 'request@vr-cargo.aero'  ? 'not-replyable' : null"
                    class="flex-item-5">reply</mat-icon>
                    <span style="font-size: 8px; margin-top: 5px;">reply all</span>
                  </div>
                </button>

                <button mat-button class="custom-email-button"
                  [disabled]="message?.from?.emailAddress?.address == 'system@vr-cargo.aero' || message?.from?.emailAddress?.address == 'request@vr-cargo.aero'"
                  (click)="$event.stopPropagation();toggleNewMail(); replyMail(message, 0)"
                  matTooltip="Reply to this message">
                  <div class="display-layout-column layout-align-center-center">
                    <mat-icon
                      [ngClass]="message?.from?.emailAddress?.address == 'system@vr-cargo.aero' || message?.from?.emailAddress?.address == 'request@vr-cargo.aero' ? 'not-replyable' : null"
                    class="flex-item-5">reply</mat-icon>
                    <span style="font-size: 8px; margin-top: 5px;">reply</span>
                  </div>
                </button>
              </div>
              <div matTooltip="Received Date Time" class="date flex-item-15">{{ message?.receivedDateTime | date:
              'dd/MM/yyyy, H:mm' }}</div>
              <div matTooltip="Send Date Time" class="date flex-item-15">{{ message?.sentDateTime | date:
              'dd/MM/yyyy,H:mm' }}</div>
              <div matTooltip="FROM" class="flex-item-20">{{ message?.from?.emailAddress?.address }}</div>
              <div matTooltip="TO" class="flex-item-20">
                <div>{{message?.toRecipients[0].emailAddress.address}} ...</div>
              </div>
              <div matTooltip="SUBJECT" class="flex-item-25">{{ message?.subject }}</div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-divider></mat-divider>
          <mat-panel-description>
            <div class="display-layout-column">
              <div class="additional-infos"><strong>Nachricht ist an folgenden Empfängern gegangen:</strong></div>
              @for (item of message?.toRecipients; track item) {
                <div>AN: {{item.emailAddress?.address}}</div>
              }
              <div style="color: lightgray;">------------------------</div>
              @for (item of message?.ccRecipients; track item) {
                <div style="margin-bottom: 10px;">CC:
                {{item.emailAddress?.address}}</div>
              }
            </div>
          </mat-panel-description>
          <mat-divider></mat-divider>
          <div class="renderHtml" [innerHTML]=" message?.body?.content | sanitizehtml"></div>
          <div class="display-layout-column layout-gap-10">
            <mat-divider></mat-divider>
            <div>Attachments</div>
            @for (attachment of getAttachments(message.id); track attachment) {
              <div>
                @for (detail of attachment.smartInfos; track detail) {
                  <div>
                    <div class="attachment-underlined" matTooltip="Click to download"
                      (click)="downloadAttachment(detail.attachmentId)">{{detail.name}}
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        </mat-expansion-panel>
      }
    </mat-accordion>
  </div>
  <mat-paginator #messagePaginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="[10,5, 20, 25]"
  (page)="pageEvent=getPagination($event)"></mat-paginator>
</div>
</div>
